// TelcoTrack — polygon portfolio-tab filter (Příprava / Stavba / Archiv / …)

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { POLYGON_PLAN_STATUS_TAB_FILTER_UI_OPTIONS } from '../../../utils/polygon-plan-status-filter.util';

@Component({
  selector: 'app-filter-polygon-plan-status',
  templateUrl: './filter-polygon-plan-status.component.html',
})
export class FilterPolygonPlanStatusComponent {
  readonly options = POLYGON_PLAN_STATUS_TAB_FILTER_UI_OPTIONS;

  @Input() selected: string[] = [];
  @Input() disabled = false;
  @Input() label = 'Stav polygonu';
  @Input() emptyLabel = 'Všechny stavy';
  @Input() controlClass = 'w-44';
  @Output() selectedChange = new EventEmitter<string[]>();

  onSelectedChange(values: string[]): void {
    this.selectedChange.emit(values);
  }
}
